// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3981) return "static/chunks/3981.f20a8c5e064433b9.js";
	if (chunkId === 1981) return "static/chunks/1981.68fb4afb1a244b3e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1631":"c2d7b96e","3692":"63b376ce"}[chunkId] || chunkId) + "-" + {"413":"329ee319610dc973","1294":"d23cac8d398c9fa1","1631":"8ec265c68888ca63","3692":"d1e7d18b6b8a4494","4166":"7cb85c44499bd55f","6095":"1b63dc3c5f277f64","7446":"4206c13e5205892c","7653":"dd3489cf6c1a598b","9351":"206a443284e1e619"}[chunkId] + ".js";
};